import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.057 3.232a.917.917 0 0 1 1.175-1.175l12.674 4.61c.63.228.81 1.035.335 1.509l-1.64 1.64a.917.917 0 0 0 0 1.296l2.936 2.936a.917.917 0 0 1 0 1.297l-2.192 2.192a.917.917 0 0 1-1.297 0L11.112 14.6a.917.917 0 0 0-1.296 0l-1.64 1.64a.917.917 0 0 1-1.51-.335L2.057 3.232ZM7.712 14.76l2.104-2.104a.917.917 0 0 1 1.296 0l3.585 3.584 1.543-1.544-3.584-3.584a.917.917 0 0 1 0-1.296l2.104-2.104L3.685 3.685 7.712 14.76Z",
  fill: "#F9F7FA"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }